import type { LogsSchema, LogsSchemaColumn } from '@repo/api-gw-sdk';

const privateColumns = [
  'cloudProvider',
  'dataSource',
  'tableName',
  'sourcePath',
  'service',
].map((name) => ({ name, type: 'varchar', private: true }));

export const dataSourcesSchemas: (LogsSchema & {
  path: string;
  schemaName: string;
  rowCount: number;
  columns: (LogsSchemaColumn & { name: string; type: string })[];
})[] = [
  {
    appName: 'CloudTrail',
    path: '/services/policy-admin/logs',
    schemaName: 'AuditTrail',
    rowCount: 79625,
    columns: [
      { name: 'id', type: 'varchar' },
      { name: 'eventTime', type: 'datetime' },
      { name: 'severity', type: 'varchar' },
      { name: 'eventVersion', type: 'varchar' },
      { name: 'eventSource', type: 'varchar' },
      { name: 'eventName', type: 'varchar' },
      { name: 'awsRegion', type: 'varchar' },
      { name: 'sourceIPAddress', type: 'varchar' },
      ...privateColumns,
    ],
  },
  {
    appName: 'Elasticsearch',
    path: '/query-perf-logs',
    schemaName: 'QueryPerformanceLogs',
    rowCount: 93843,
    columns: [
      { name: 'id', type: 'varchar' },
      { name: 'eventTime', type: 'datetime' },
      { name: 'severity', type: 'varchar' },
      { name: 'user', type: 'varchar' },
      { name: 'query', type: 'varchar' },
      { name: 'index', type: 'varchar' },
      { name: 'took_ms', type: 'integer' },
      { name: 'hits', type: 'integer' },
      { name: 'sourceIpAddress', type: 'varchar' },
      ...privateColumns,
    ],
  },
  {
    appName: 'Nginx',
    path: '/cental-access-logs/s3/prod-user-access-logs',
    schemaName: 'AccessLogs',
    rowCount: 54322,
    columns: [
      { name: 'id', type: 'varchar' },
      { name: 'eventTime', type: 'datetime' },
      { name: 'severity', type: 'varchar' },
      { name: 'remote_addr', type: 'varchar' },
      { name: 'method', type: 'varchar' },
      { name: 'path', type: 'varchar' },
      { name: 'status', type: 'integer' },
      { name: 'bytes_sent', type: 'integer' },
      { name: 'user_agent', type: 'varchar' },
      ...privateColumns,
    ],
  },
  {
    appName: 'Sentinel',
    path: '/sentinel-events',
    schemaName: 'SecurityEvents',
    rowCount: 63233,
    columns: [
      { name: 'id', type: 'varchar' },
      { name: 'eventTime', type: 'datetime' },
      { name: 'severity', type: 'varchar' },
      { name: 'provider', type: 'varchar' },
      { name: 'product', type: 'varchar' },
      { name: 'ruleName', type: 'varchar' },
      { name: 'category', type: 'varchar' },
      { name: 'computer', type: 'varchar' },
      { name: 'account', type: 'varchar' },
      { name: 'srcIpAddress', type: 'varchar' },
      { name: 'srcCountry', type: 'varchar' },
      { name: 'action', type: 'varchar' },
      { name: 'operationName', type: 'varchar' },
      { name: 'tenantId', type: 'varchar' },
      { name: 'workspace', type: 'varchar' },
      ...privateColumns,
    ],
  },
  {
    appName: 'Sentinel',
    path: '/sentinel-logs',
    schemaName: 'AzureActivity',
    rowCount: 1233312,
    columns: [
      { name: 'id', type: 'varchar' },
      { name: 'eventTime', type: 'datetime' },
      { name: 'severity', type: 'varchar' },
      { name: 'category', type: 'varchar' },
      { name: 'operationName', type: 'varchar' },
      { name: 'initiatedBy', type: 'varchar' },
      { name: 'resource', type: 'varchar' },
      { name: 'sourceIpAddress', type: 'varchar' },
      { name: 'status', type: 'varchar' },
      { name: 'tenantId', type: 'varchar' },
      { name: 'workspace', type: 'varchar' },
      ...privateColumns,
    ],
  },
];
